import React from 'react';
import {  Glyphicon, Tab, Row, Col, Navbar, Nav, NavItem } from 'react-bootstrap';
import GridSquarePanel from './GridSquarePanel.js';
import EmStatsPanel from './EmStatsPanel.js';

export class GridPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeKey: "Summary"
        };
        // This binding is necessary to make `this` work in the callback
        this.handleSelect = this.handleSelect.bind(this);
    }
    parseStartTimeList(){
        if (this.props.startTimeList){
            try{
                return this.props.startTimeList.split(',')[0];
            }
            catch(e){
                return null;
            }
        }
    }
    handleSelect(key) {                 
        this.setState({
            activeKey : key
        });
     }
 
    render() {          
        return <div style={{  borderLeft:'1px solid #ddd',borderRight:'1px solid #ddd', borderBottom:'1px solid #ddd',borderRadius: '15px'}}>
            <Navbar collapseOnSelect fluid>
                <Navbar.Header>
                    <Navbar.Brand>
                        <Glyphicon glyph="time" />
                        <span style={{fontSize:'10px', marginLeft:'10px'}}>{this.parseStartTimeList()}</span>
                        <span style={{marginLeft:'30px'}}>{this.props.experimentType} </span> 
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>                 
                    <Nav pullRight>
                        <NavItem eventKey="Stats" href="#"  onSelect={this.handleSelect.bind(this)}>Stats</NavItem>
                    </Nav>
                    <Nav pullRight>
                        <NavItem eventKey="Summary" href="#"  onSelect={this.handleSelect.bind(this)}>Summary</NavItem>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
            <Tab.Container activeKey={this.state.activeKey} onSelect={this.handleSelect} id="em-tab-container">
                <Tab.Content animation>
                    <Tab.Pane eventKey="Summary">
                        <GridSquarePanel {...this.props}></GridSquarePanel>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Stats">
                        <EmStatsPanel {...this.props}></EmStatsPanel>
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </div>;
}
}





// WEBPACK FOOTER //
// ./src/components/Em/GridPanel.js